import clsx from "clsx";
import { createModal, Col, ModalProps, useModal, Typography } from "@commonlibs";
import type { LocalGiftCardDto } from "common/models/api/models/LocalGiftCardDto";
import Modal from "ui/common/components/feedback/Modal/Modal";
import ModalFooter from "ui/common/components/feedback/Modal/ModalFooter/ModalFooter";
import useTranslate from "ui/locale/hooks/useTranslate";
import GiftCardModal from "../GiftCardForm/GiftCardFormModal";

const GiftCardTermsAndConditionsModal = createModal<{ giftCard: LocalGiftCardDto } & ModalProps>(({ className, giftCard, ...rest }) => {
    const translate = useTranslate();
    const { showModal, hideModal } = useModal();

    function closeModal() {
        hideModal(GiftCardTermsAndConditionsModal.id);
    }

    function onEdit() {
        hideModal(GiftCardTermsAndConditionsModal.id);
        setTimeout(() => {
            showModal(GiftCardModal, { giftCard });
        }, 500);
    }

    return (
        <Modal
            title={translate("termsAndConditions")}
            className={clsx("giftcard-terms-and-conditions-modal", className)}
            style={{ width: "600px" }}
            {...rest}
        >
            <Col gap={20}>
                <Typography variant="body2Regular" style={{ whiteSpace: "pre-line" }}>
                    {giftCard.termsAndConditions}
                </Typography>

                <ModalFooter
                    cancelLabel={translate("goOut") as string}
                    mainLabel={translate("edit")}
                    onCancel={closeModal}
                    onSubmit={onEdit}
                />
            </Col>
        </Modal>
    );
});

export default GiftCardTermsAndConditionsModal;
